var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NumericKeypad',{attrs:{"title":_vm.$t('OPERATOR_CODE') + ':'},on:{"okClicked":function($event){return _vm.$emit('operatorCodeAdded', $event)},"cancelClicked":function($event){return _vm.$emit('operatorDialogCanceled')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }